import {Pipe, PipeTransform} from '@angular/core';
import {interval, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'animateNumber',
  pure: false
})
export class AnimateNumberPipe implements PipeTransform {
  // TODO Remove this class
  transform(value: number): Observable<number> {
    return interval(1000).pipe(
      map(value => value)
    );
  }

}
